import type { SagaIterator } from "redux-saga";
import { fork, put, take } from "redux-saga/effects";
import { getType } from "typesafe-actions";

import type { IIndustryConfig } from "@/shop/types/industry";

import * as IndustryActions from "./actions";

function* fetchIndustryConfig(): SagaIterator {
  try {
    // flag as fetching
    yield put(IndustryActions.fetchIndustryConfigStart());

    // call the api to retrieve the session
    const industryConfig: IIndustryConfig = null!;

    yield put(IndustryActions.fetchIndustryConfigSuccess(industryConfig));
  } catch (err) {
    // fetch failed, handle the error
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    yield put(IndustryActions.fetchIndustryConfigFail(err));
  }
}

function* fetchIndustryConfigOnce(): SagaIterator {
  yield take(getType(IndustryActions.fetchIndustryConfig));
  yield fork(fetchIndustryConfig);
}

export default function* industrySaga(): SagaIterator {
  yield fork(fetchIndustryConfigOnce);
}
